import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Coins, Loader2 } from 'lucide-react';
import { money } from './DeskForms';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-credit-cashout/convert`;
const split = (gross, pct) => { const g = Math.round(gross * 100); const fee = Math.round((g * pct) / 100 + 1e-9); return [fee / 100, (g - fee) / 100]; };

export const CreditToBethCard = ({ token, onDone }) => {
  const [st, setSt] = useState(null);
  const [amount, setAmount] = useState('');
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    axios.get(`${API}/status`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setSt(r.data)).catch(() => {});
  }, [token]);
  useEffect(() => { load(); }, [load]);
  if (!st) return null;
  const amt = parseFloat(amount);
  const [fee, net] = split(amt || 0, st.fee_pct);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await axios.post(API, { amount_usd: amt }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(r.data.message); setAmount(''); load(); onDone && onDone();
    } catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Conversion failed'); }
    setBusy(false);
  };

  return (
    <div className="bg-slate-900 rounded-2xl p-5 border border-cyan-500/30" data-testid="credit-to-beth-card">
      <h2 className="font-semibold flex items-center gap-2 mb-1"><Coins className="w-5 h-5 text-cyan-400" /> Turn credit into BETH USD for trading</h2>
      <p className="text-xs text-slate-400 mb-4">Draw from your credit line and receive the same dollars as BETH USD in your wallet, ready to swap. New BETH can only be created while there is dollar reserve room to back it.</p>
      <div className="grid grid-cols-3 gap-3 mb-4 text-center">
        <div className="bg-slate-800/60 rounded-lg p-2"><p className="text-[11px] text-slate-400">Unused credit</p><p className="font-bold" data-testid="convert-available">{money(st.available_credit_usd)}</p></div>
        <div className="bg-slate-800/60 rounded-lg p-2"><p className="text-[11px] text-slate-400">Reserve room</p><p className="font-bold" data-testid="convert-reserve-room">{money(st.reserve_room_usd)}</p></div>
        <div className="bg-slate-800/60 rounded-lg p-2"><p className="text-[11px] text-slate-400">You can convert</p><p className="font-bold text-cyan-300" data-testid="convert-max">{money(st.max_convert_usd)}</p></div>
      </div>
      {!st.can_convert ? <p className="text-sm text-amber-300" data-testid="convert-blocked">{st.blocked_reason}</p> : (
        <div className="space-y-3">
          <input type="number" min="1" step="0.01" placeholder="Amount of credit to convert (USD)" value={amount} onChange={(e) => setAmount(e.target.value)}
            className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white text-sm" data-testid="convert-amount" />
          <div className="text-xs text-slate-400 bg-slate-800/60 rounded-lg p-3 space-y-1" data-testid="convert-breakdown">
            <p className="flex justify-between"><span>Fee ({st.fee_pct}%)</span><span>{money(fee)}</span></p>
            <p className="flex justify-between text-white font-semibold"><span>BETH USD you receive</span><span>{money(net)}</span></p>
          </div>
          <button onClick={submit} disabled={busy || !(amt >= 1) || amt > st.max_convert_usd} data-testid="convert-submit"
            className="w-full py-2.5 bg-cyan-600 hover:bg-cyan-500 disabled:opacity-40 text-white rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition-colors">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} {busy ? 'Minting on Base…' : 'Convert to BETH USD'}
          </button>
        </div>
      )}
    </div>
  );
};
